var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUcs20(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67191 15.3594L3.98828 14.1191L1.09375 18.3496L6.21484 18.0156L5.51556 16.9771L10.1913 14.3052L9.34769 12.6875L4.67191 15.3594Z",
    fill: "#4B4BD1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77729 14.1192L14.4531 16.791L13.7851 18.0156L18.9062 18.3496L16.0117 14.1192L15.3925 15.2533L10.7167 12.5814L9.77729 14.1192Z",
    fill: "#E32B2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 1.65039L12.2266 6.21484H10.9393V13.8965H9.11285V6.21484H7.77344L10 1.65039Z",
    fill: "#52D052"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7871 1.65039H15.7891L14.4531 4.09961V5.54688H13.5625V4.09961L12.2266 1.65039H13.2285L14.0078 3.43164L14.7871 1.65039ZM16.3457 12.7832H15.3438L16.6797 10.7793L15.4551 8.77539H16.457L17.125 10.1113L17.9043 8.77539H18.9062L17.6816 10.668L18.9062 12.7832H17.9043L17.125 11.4473L16.3457 12.7832ZM1.09375 12.1152L3.09766 9.44336H1.09375V8.77539H4.09961V9.44336L2.0957 12.1152H4.21094V12.7832H1.09375V12.1152Z",
    fill: "#626262"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUcs20);
export default __webpack_public_path__ + "static/media/ucs_20.1a3e0ed2f5a0d4a862d30116df6d91d8.svg";
export { ForwardRef as ReactComponent };